'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { track } from '@/lib/analytics/track'

interface TryInSokuButtonProps {
  slug: string
  category: string
}

export function TryInSokuButton({ slug, category }: TryInSokuButtonProps) {
  return (
    <Link
      href={`/sign-up?ref=gpt-image-2-prompts&prompt=${encodeURIComponent(slug)}`}
      onClick={() => track('gpt_image_2_prompt_try', { slug, category })}
      className="inline-flex h-9 flex-1 items-center justify-center gap-1.5 rounded-md bg-foreground px-3 text-sm font-medium text-background transition-opacity hover:opacity-90"
    >
      Try in Soku AI
      <ArrowRight className="h-4 w-4" />
    </Link>
  )
}
